export default __webpack_public_path__ + "static/media/silencer-protector.9add994c.glb";